module.exports = __webpack_public_path__ + "media/images/icons/people-bb9c78c97f668df761dbb8916253ea32.svg";